import styled from 'styled-components';

import { palette } from '../../config/theme';

export const Subtext = styled.div`
  color: ${palette('subtext')};
  margin-bottom: 8px;
`;
